// extracted by mini-css-extract-plugin
module.exports = {"card":"Menu_card__2Fp7l","loadingMsg":"Menu_loadingMsg__7EHbO","animate":"Menu_animate__1rtpv"};